


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../config';
// import { LoadingSpinner } from '../../Components/spinner/spinner';

// export const StaffAssetPropertyDetailsComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
//     { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
//     { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },
//     { id: 'notification', field: 'notification', headerName: 'Notification', width: 150 },
//     { id: 'date', field: 'date', headerName: 'Date', width: 120 },
//     { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },
//     { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
//     { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
//     { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },
//     { id: 'type_of_asset', field: 'type_of_asset', headerName: 'Type of Asset', width: 150 },
//     { id: 'hobli', field: 'hobli', headerName: 'Hobli', width: 120 },
//     { id: 'village', field: 'village', headerName: 'Village', width: 120 },
//     { id: 'taluk', field: 'taluk', headerName: 'Taluk', width: 120 },
//     { id: 'district', field: 'district', headerName: 'District', width: 120 },
//     { id: 'state', field: 'state', headerName: 'State', width: 120 },
//     { id: 'pincode', field: 'pincode', headerName: 'Pincode', width: 100 },
//     { id: 'geo_location', field: 'geo_location', headerName: 'Geo Location', width: 200 },
//   ];

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/asset-mgmt/asset-property/`)
//       .then((response) => {
//         console.log('API Response:', response.data);

//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           name_of_fe: item.asset3_2_base?.fe?.name_of_fe || '-',
//           name_of_ca: item.asset3_2_base?.fe?.name_of_ca || '-',
//           notification: item.asset3_2_base?.notification || '-',
//           date: item.asset3_2_base?.date
//             ? new Date(item.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-')
//             : '-',
//           notification_no: item.asset3_2_base?.notification_no || '-', // nested path

//           // property details (matching backend field names exactly)
//           property_detals: item.property_detals || '-',
//           survey_no: item.survey_no || '-',
//           property_type: item.property_type || '-',
//           type_of_asset: item.type_of_asset || '-',
//           hobli: item.hobli || '-',
//           village: item.village || '-',
//           taluk: item.taluk || '-',
//           district: item.district || '-',
//           state: item.state || '-',
//           pincode: item.pincode || '-',
//           geo_location: item.geo_location || '-',
//         }));

//         setRows(apiData);
//         setSnackbarMessage('Asset Property Details data loaded successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Error fetching Asset Property Details:', error);
//         setSnackbarMessage('Failed to load Asset Property Details data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, []);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box
//         display="flex"
//         justifyContent="center"
//         backgroundColor="rgba(195, 234, 203, 0.1)"
//         mb={2}
//       >
//         <Typography
//           variant="h4"
//           component="h1"
//           align="center"
//           sx={{ fontWeight: 'bold' }}
//         >
//           Asset Property Details
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';

export const StaffAssetPropertyDetailsComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
    { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
    { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },
    {
      id: 'notification',
      field: 'notification',
      headerName: '3(2) Notification',
      width: 180,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
    { id: 'date', field: 'date', headerName: 'Date', width: 120 },
    { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },
    { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
    { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
    { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },
    { id: 'type_of_asset', field: 'type_of_asset', headerName: 'Type of Asset', width: 150 },
    { id: 'hobli', field: 'hobli', headerName: 'Hobli', width: 120 },
    { id: 'village', field: 'village', headerName: 'Village', width: 120 },
    { id: 'taluk', field: 'taluk', headerName: 'Taluk', width: 120 },
    { id: 'district', field: 'district', headerName: 'District', width: 120 },
    { id: 'state', field: 'state', headerName: 'State', width: 120 },
    { id: 'pincode', field: 'pincode', headerName: 'Pincode', width: 100 },
    {
      id: 'geo_location',
      field: 'geo_location',
      headerName: 'Geo Location',
      width: 200,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            Locate
          </a>
        ) : (
          <span>-</span>
        ),
    },
  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/asset-mgmt/asset-property/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          name_of_fe: item.asset3_2_base?.fe?.name_of_fe || '-',
          name_of_ca: item.asset3_2_base?.fe?.name_of_ca || '-',
          notification: item.asset3_2_base?.notification|| '-',
          date: item.asset3_2_base?.date
            ? new Date(item.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          notification_no: item.asset3_2_base?.notification_no || '-',
          property_detals: item.property_detals || '-',
          survey_no: item.survey_no || '-',
          property_type: item.property_type || '-',
          type_of_asset: item.type_of_asset || '-',
          hobli: item.hobli || '-',
          village: item.village || '-',
          taluk: item.taluk || '-',
          district: item.district || '-',
          state: item.state || '-',
          pincode: item.pincode || '-',
          geo_location: item.geo_location || '-', // expects URL here
        }));

        setRows(apiData);
        setSnackbarMessage('Asset Property Details data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching Asset Property Details:', error);
        setSnackbarMessage('Failed to load Asset Property Details data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          Asset Property Details
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
